import { InputNumber } from "antd"
import style from "./NumberInputRow.module.scss"

const { row, labelGroup, label, requiredMark, inputWrapper, numberInput } = style

type Props = {
	label: string
	required?: boolean
	value: number | null
	onChange: (value: number | null) => void
	onBlur?: () => void
	disabled?: boolean
	min?: number
	max?: number
	/**
	 * Shown while the input is empty. The batch panel (REQ-403) puts `Mixed` here when the selected
	 * objects hold different values — the field is genuinely empty, and typing is what applies one
	 * value to all of them.
	 */
	placeholder?: string
}

export const NumberInputRow = ({
	label: labelText,
	required = false,
	value,
	onChange,
	onBlur,
	disabled = false,
	min = 0,
	max,
	placeholder,
}: Props) => {
	return (
		<div className={row}>
			<div className={labelGroup}>
				<span className={label}>{labelText}</span>
				{required ? <span className={requiredMark}>*</span> : null}
			</div>
			<div className={inputWrapper}>
				<InputNumber
					className={numberInput}
					value={value}
					onChange={(v) => onChange(typeof v === "number" ? v : null)}
					onBlur={onBlur}
					onPressEnter={onBlur}
					placeholder={placeholder}
					disabled={disabled}
					min={min}
					max={max}
					// Counts only — the one field this row renders (`adjusted_shelves`) is an integer on
					// both the single-object and the batch configuration endpoints.
					precision={0}
					controls={false}
				/>
			</div>
		</div>
	)
}
